import { KeyboardEvent as ReactKeyboardEvent } from 'react'

export type KeyboardKey =
    | 'A'
    | 'B'
    | 'C'
    | 'D'
    | 'E'
    | 'F'
    | 'G'
    | 'H'
    | 'I'
    | 'J'
    | 'K'
    | 'L'
    | 'M'
    | 'N'
    | 'O'
    | 'P'
    | 'Q'
    | 'R'
    | 'S'
    | 'T'
    | 'U'
    | 'V'
    | 'W'
    | 'X'
    | 'Y'
    | 'Z'
    | '.'
    | '-'
    | 'ESCAPE'

export const VALID_KEYS = new Set<KeyboardKey>([
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    '.',
    '-',
    'ESCAPE',
])

/**
 * Maps keyboard event code values (e.g. "Period", "Minus") to their corresponding key values.
 * Used to normalize key codes from the backend (configurator) to the key format used in the UI.
 */
const KEY_CODE_TO_KEY: Record<string, KeyboardKey> = {
    Period: '.',
    Minus: '-',
}

/** Normalizes a keyboard shortcut value that may be a key code (e.g. "Period") to a key value (e.g. ".") */
export const normalizeKeyboardShortcut = (shortcut: string): KeyboardKey => {
    const mapped = KEY_CODE_TO_KEY[shortcut]
    if (mapped) return mapped
    const upper = shortcut.toUpperCase()
    if (VALID_KEYS.has(upper as KeyboardKey)) return upper as KeyboardKey
    return shortcut as KeyboardKey
}

export type KeyboardShortcut = {
    keyboardKey: KeyboardKey
    hasShift?: boolean
    hasMeta?: boolean
    hasCtrl?: boolean
}

export function isShortcutPressed(event: ReactKeyboardEvent | KeyboardEvent, shortcut: KeyboardShortcut): boolean {
    const { keyboardKey, hasShift, hasMeta, hasCtrl } = shortcut
    if (!event.key) {
        return false
    }
    const isKeyPressed = event.key.toUpperCase() === keyboardKey

    if (hasShift && !event.shiftKey) return false
    if (hasMeta && !event.metaKey) return false
    if (hasCtrl && !event.ctrlKey) return false

    return isKeyPressed
}
